import { CAR_VIEWBOX, CAR_PATH } from "./generated/car";
import { ArhDefs } from "./plan/arhMaterial";

export function Defs() {
  return (
    <defs>
      {/* Materialele pardoselii și umbrele planului de arhitectură. Stau aici,
          nu într-un `<defs>` al lor, fiindcă un al doilea `<defs>` în aceeași
          pânză e tot un `<defs>` — dar două locuri de căutat când un `url(#…)`
          nu se leagă. */}
      <ArhDefs />
      <symbol id="pg-car" viewBox={CAR_VIEWBOX} dangerouslySetInnerHTML={{ __html: CAR_PATH }} />
      <pattern id="pg-hatch" width={6} height={6} patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
        <line x1={0} y1={0} x2={0} y2={6} stroke="var(--hair)" strokeWidth={1} />
      </pattern>
      {/* A03 fills every REI wall with a CROSS-hatch, not a single set of
          diagonals — it is what makes a rated wall read as rated on that sheet. */}
      <pattern id="pg-fire-hatch" width={0.16} height={0.16} patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
        <line x1={0} y1={0} x2={0} y2={0.16} stroke="var(--fire)" strokeWidth={0.035} />
        <line x1={0} y1={0} x2={0.16} y2={0} stroke="var(--fire)" strokeWidth={0.035} />
      </pattern>
      {/* the access strip beside a pair of accessible bays — reserved floor, so it
          reads as hatched rather than as a surface anything may occupy */}
      <pattern id="pg-ada-hatch" width={0.45} height={0.45} patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
        <line x1={0} y1={0} x2={0} y2={0.45} stroke="var(--car-ada-line)" strokeWidth={0.1} />
      </pattern>
    </defs>
  );
}
